export default __webpack_public_path__ + "static/media/04.54e95d72.jpg";